import styled from 'styled-components';

export const FlexGrow = styled.div`
  flex-grow: 1;
`;

export const RowHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`;

export const RowHeader = styled.div`
  font-size: 16px;
  font-weight: 600;
  height: 22px;
`;
